var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c(_vm.layout,{tag:"component"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('snack-bar'),(_vm.isShowLoading)?_c('progress-circular'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }